import StartInvestPersonRequirements from "../components/forms/start-invest-requirements/StartInvestPersonRequirements";

function PersonFormRequirements() {
    return ( <StartInvestPersonRequirements/> );
}

export default PersonFormRequirements;